<div #editor class="editor-container"></div>
<div *ngIf="toolbarVisible" class="toolbar">
  <pm-toolbar [editorView]="editorView"></pm-toolbar>
</div>
<ng-template [ngTemplateOutlet]="footerTmpl"></ng-template>
